export default "__VITE_ASSET__bFzvvvfM__"